<template>
        <v-container v-show="$store.state.showCrud">
            <v-layout justify-end column>
                <v-flex xs12>
                    <v-layout justify-end>
                        <v-btn type="button" round color="#FF7BA3" class="whiteText" v-on:click="toAdminHome">
                            <v-icon>exit_to_app</v-icon>
                        </v-btn>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex>
                    <v-card class="formCrud">
                        <v-container>
                            <v-layout>
                                <v-flex md9 xs9>
                                    <v-text-field
                                            id="questionField"
                                            outline
                                            label="Pregunta"
                                            color="cyan"
                                            background-color="cyan"
                                            v-model="newQuestion[selectLanguage].text"
                                    >

                                    </v-text-field>
                                </v-flex>
                                <v-layout justify-center>
                                    <v-flex md7 xs7>
                                        <v-select
                                                id="categoryField"
                                                v-model="selectCategory"
                                                :items="categories"
                                                label="Categories"
                                                color="warning"
                                                required
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                            <v-text-field
                                    id="correctAnswerField"
                                    flat
                                    label="Resposta Correcta"
                                    color="cyan"

                                    v-model="newQuestion[selectLanguage].correctAnswer"

                            >

                            </v-text-field>
                            <v-text-field
                                    id="answer1Field"
                                    flat
                                    label="Resposta1"
                                    color="red"
                                    v-model="newQuestion[selectLanguage].answer1"

                            >

                            </v-text-field>
                            <v-text-field
                                    id="answer2Field"
                                    flat
                                    label="Resposta2"
                                    color="red"
                                    v-model="newQuestion[selectLanguage].answer2"

                            >

                            </v-text-field>
                            <v-text-field
                                    id="answer3Field"
                                    flat
                                    label="Resposta3"
                                    color="red"
                                    v-model="newQuestion[selectLanguage].answer3"

                            >

                            </v-text-field>
                            <br>

                            <v-layout>
                                <v-layout justify-end>
                                    <v-btn flat color="cyan" @click="refresh"><i class="material-icons">queue</i>
                                    </v-btn>
                                    <v-btn flat color="cyan" @click="saveQuestion()"><i class="material-icons">save</i>
                                    </v-btn>
                                </v-layout>
                            </v-layout>
                        </v-container>

                        <v-layout justify-center>
                            <v-btn
                                    class="buttonsLanguage"
                                    flat
                                    v-for="lang in languages"
                                    :key="lang.text"
                                    v-model="selectLanguage"
                                    :class="{active: lang.buttonSelected}"
                                    @click="returnValue(lang)"
                            >
                                <i class="material-icons">flag</i>
                                {{lang.text}}
                            </v-btn>
                        </v-layout>
                        <br>
                    </v-card>
                    <br>
                    <br>
                    <br>
                    <v-card class="questionsText" color="cyan">
                        <v-container>
                            <v-select
                                    id="categoryField2"
                                    outline
                                    background-color="white"
                                    color="dark"
                                    v-model="selectCategory2"
                                    :items="categories"
                                    label="Categories"
                                    required
                                    v-on:change="showCategoria"
                            ></v-select>

                            <v-layout
                                    justify-center
                                    align-center
                                    v-for="question in showPreguntes" :key="question.key"
                            >
                                <v-flex md9>
                                    <v-spacer></v-spacer>
                                    <b class="textShowQuestions">{{question[selectLanguage].text}}</b>
                                    <v-spacer></v-spacer>
                                    <v-divider></v-divider>
                                </v-flex>
                                <v-flex md2 xs6>
                                    <v-layout>
                                        <v-btn flat color="white" v-on:click="modifyQuestion(question)"><i
                                                class="material-icons">create</i>
                                        </v-btn>
                                        <v-btn flat color="white" v-on:click="deleteQuestion(question)"><i
                                                class="material-icons">delete</i>
                                        </v-btn>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
</template>


<style scoped>

</style>


<script>
    import VueFire from 'vuefire'
    import Vue from 'vue'
    import {db} from '../firebaseConfig'
    import Noty from 'noty'
    import 'vuejs-noty/dist/vuejs-noty.css'

    Vue.use(VueFire);

    let questionsRef = db.ref('Questions');

    export default {
        name: 'QuestionsCRUD',
        firebase: {
            questionsRef
        },
        data() {
            return {
                showCrud2: this.$store.state.showCrud,
                showHome2: this.$store.state.showHome,
                categories: ['Cues i Xifres', 'Documents', 'Empadronament', 'Estrangeria', 'Cens electoral', 'Territori'],
                selectLanguage: '',
                questionToModify: '',
                buttonSelected: true,
                propCategory: '',
                newQuestion: {
                    category: '',
                    'Cat': {
                        text: '',
                        correctAnswer: '',
                        answer1: '',
                        answer2: '',
                        answer3: ''
                    },
                    'Es': {
                        text: '',
                        correctAnswer: '',
                        answer1: '',
                        answer2: '',
                        answer3: ''
                    },
                    'En': {
                        text: '',
                        correctAnswer: '',
                        answer1: '',
                        answer2: '',
                        answer3: ''
                    }
                },

                languages: [
                    {
                        buttonSelected: true,
                        text: 'Cat'
                    },
                    {
                        buttonSelected: false,
                        text: 'Es'
                    },
                    {
                        buttonSelected: false,
                        text: 'En'
                    }
                ],

                // seleccio de les categories
                selectCategory: '',
                selectCategory2: '',

                // aqui es guardaran les preguntes que es mostraran a la selectCategory2
                showPreguntes: []
            }
        },
        created() {
            this.selectLanguage = 'Cat';
            this.showCategoria();
        },
        methods: {
            returnValue(lang) {
                this.selectLanguage = lang.text;
                // treu el color als botons que no s'han selecionat anteriorment
                for (let i = 0; i < this.languages.length; i++) {
                    if (this.languages[i].text === lang.text) {
                        lang.buttonSelected = true
                    } else if (this.languages[i].text !== lang.text) {
                        this.languages[i].buttonSelected = false
                    }
                }
            },
            // Verifica el camps obligatoris del formulari
            checkField() {
                let verificar = true;

                if (this.newQuestion.category === '') {
                    new Noty({
                        layout: 'topCenter',
                        type: 'warning',
                        text: 'Selecciona categoria',
                        timeout: 2500
                    }).show();
                    verificar = false
                }

                for (let i = 0; i < this.languages.length; i++) {
                    if (this.newQuestion[this.languages[i].text].correctAnswer === '') {
                        new Noty({
                            layout: 'topCenter',
                            type: 'warning',

                            text: 'Introdueix la pregunta correcte en ' + this.languages[i].text,
                            timeout: 2500
                        }).show();
                        verificar = false
                    } else if (this.newQuestion[this.languages[i].text].text === '') {
                        new Noty({
                            layout: 'topCenter',
                            type: 'warning',

                            text: 'Introdueix la pregunta en ' + this.languages[i].text,
                            timeout: 2500
                        }).show();
                        verificar = false;

                        return verificar
                    } else if (this.newQuestion[this.languages[i].text].answer1 === '') {
                        new Noty({
                            layout: 'topCenter',
                            type: 'warning',

                            text: 'Introdueix la resposta1 en ' + this.languages[i].text,
                            timeout: 2500
                        }).show();
                        verificar = false
                    }
                }

                return verificar
            },
            saveQuestion() {
                let exist = false;
                let question = '';

                let textField = document.getElementById('questionField').value;
                let correctAnswerField = document.getElementById('correctAnswerField').value;
                let answer1Field = document.getElementById('answer1Field').value;
                let answer2Field = document.getElementById('answer2Field').value;
                let answer3Field = document.getElementById('answer3Field').value;

                this.newQuestion.category = this.selectCategory;
                this.newQuestion[this.selectLanguage].text = textField;
                this.newQuestion[this.selectLanguage].correctAnswer = correctAnswerField;
                this.newQuestion[this.selectLanguage].answer1 = answer1Field;
                this.newQuestion[this.selectLanguage].answer2 = answer2Field;
                this.newQuestion[this.selectLanguage].answer3 = answer3Field;

                let verificar = this.checkField();

                if (verificar === true) {
                    for (let i = 0; i < this.questionsRef.length; i++) {
                        if (this.questionToModify.key === this.questionsRef[i]['.key']) {
                            exist = true;
                            // guardem l'bjecte que es igual a la key per despres utilitzarlo
                            question = this.questionsRef[i]
                        } else {
                            exist = false
                        }
                    }
                    if (exist === true) {
                        questionsRef.child(question['.key']).update(this.newQuestion);
                        new Noty({
                            layout: 'topCenter',
                            type: 'info',
                            text: 'Modificat!',
                            timeout: 1500
                        }).show();

                        this.showCategoria()
                    } else {
                        questionsRef.push(this.newQuestion);

                        new Noty({
                            layout: 'topCenter',
                            type: 'success',
                            text: 'Pregunta guardada!',
                            timeout: 1500
                        }).show()
                    }
                }
                this.showCategoria();
            },
            refresh() {
                this.questionToModify = '';

                this.newQuestion.category = '';
                this.selectCategory = '';
                this.newQuestion.Cat.text = '';
                this.newQuestion.Cat.correctAnswer = '';
                this.newQuestion.Cat.answer2 = '';
                this.newQuestion.Cat.answer1 = '';
                this.newQuestion.Cat.answer3 = '';
                this.newQuestion.Es.text = '';
                this.newQuestion.Es.correctAnswer = '';
                this.newQuestion.Es.answer2 = '';
                this.newQuestion.Es.answer1 = '';
                this.newQuestion.Es.answer3 = '';
                this.newQuestion.En.text = '';
                this.newQuestion.En.correctAnswer = '';
                this.newQuestion.En.answer2 = '';
                this.newQuestion.En.answer1 = '';
                this.newQuestion.En.answer3 = ''
            },
            showCategoria() {
                this.showPreguntes = [];
                for (let i = 0; i < this.questionsRef.length; i++) {
                    if (this.selectCategory2 === this.questionsRef[i].category) {
                        this.showPreguntes.push(this.questionsRef[i])
                    }
                }
            },
            deleteQuestion(question) {

                let this2 = this;
                let n = new Noty({
                    text: 'Estas segur?',
                    type: 'information',
                    layout: 'center',
                    theme: 'metroui',
                    buttons: [
                        Noty.button('Si ', 'v-btn error', function () {
                            n.close();
                            questionsRef.child(question['.key']).remove();
                            this2.showCategoria();
                            new Noty({
                                layout: 'topCenter',
                                type: 'error',
                                text: 'Eliminat',
                                timeout: 1500
                            }).show();

                        }),
                        Noty.button('No', ' v-btn warning', function () {
                            n.close()
                        })
                    ]
                }).show()
            },
            modifyQuestion(question) {
                // this.newQuestion.category = questionsRef.child(question['category'])
                this.selectCategory = question.category;

                this.newQuestion.Cat.text = question.Cat.text;
                this.newQuestion.Cat.correctAnswer = question.Cat.correctAnswer;
                this.newQuestion.Cat.answer1 = question.Cat.answer1;
                this.newQuestion.Cat.answer2 = question.Cat.answer2;
                this.newQuestion.Cat.answer3 = question.Cat.answer3;
                this.newQuestion.Es.text = question.Es.text;
                this.newQuestion.Es.correctAnswer = question.Es.correctAnswer;
                this.newQuestion.Es.answer1 = question.Es.answer1;
                this.newQuestion.Es.answer2 = question.Es.answer2;
                this.newQuestion.Es.answer3 = question.Es.answer3;
                this.newQuestion.En.correctAnswer = question.En.correctAnswer;
                this.newQuestion.En.text = question.En.text;
                this.newQuestion.En.answer1 = question.En.answer1;
                this.newQuestion.En.answer2 = question.En.answer2;
                this.newQuestion.En.answer3 = question.En.answer3;

                // guardem l'bjecte question que volem modificar amb la seva key especifica
                this.questionToModify = questionsRef.child(question['.key'])
            },
            toAdminHome() {
                this.$store.commit('showAdminHomeTrue');
                this.$store.commit('showCrudFalse');
            }
        }
    }
</script>

<style scoped>

    .whiteText{
        z-index: 2;
        color:white;
    }

    .formCrud {
        box-shadow: 0px 0px 80px #696969;
        border-radius: 20px;
    }


    .questionsText {
        box-shadow: 0px 0px 10px #696969;
        border-radius: 20px;
    }

    /*.buttonsIdioma{*/
    /*box-shadow: 0px 2px 5px rgba(105, 105, 105, 0.42);*/
    /*}*/

    .textShowQuestions {
        color: white;
    }

    .buttonsLanguage {
        background-color: #E0F7FA;
        color: lightgray;

    }

    .active {
        background-color: #00BCD4;
        color: white;
    }

    .confirmDelete {
        box-shadow: 0px 0px 300px #696969;
        color: white;
    }


    .buttonConfirmDelete {
        height: 20px;
        font-size: 10px;
    }

</style>
